<template>
  <a class="ghost-button-link">
    <VIconMTS v-if="icon" :name="icon" />
    <span><slot></slot></span>
  </a>
</template>

<script>
import VIconMTS from '@/components/Common/MTS/VIconMTS.vue'

export default {
  name: 'BaseGhostButtonLink',
  components: { VIconMTS },
  props: {
    icon: {
      type: String,
      default: ''
    },
  }
}
</script>

<style scoped lang="scss">
.ghost-button-link {
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: #FFFFFF1A;
  }

  span {
    font-family: $font-mts-wide;
    font-weight: 700;
    letter-spacing: 0.5px;
    color: $color-dark-2;
    text-align: center;
    text-transform: uppercase;
  }

  svg {
    width: 24px;
    height: 24px;
    fill: $color-gray-dark-2;
  }

  &.--xl {
    padding: 24px;
    border-radius: 20px;

    span {
      padding: 2px 8px;
      font-size: 14px;
      line-height: 20px;
    }
  }

  &.--l,
  &.--m {
    border-radius: 16px;

    span {
      padding: 4px 8px;
      font-size: 12px;
      line-height: 16px;
    }
  }

  &.--l {
    padding: 14px;
  }

  &.--m {
    padding: 10px;
  }

  &.--s {
    padding: 8px;
    border-radius: 12px;

    span {
      padding: 2px 4px;
      font-size: 10px;
      line-height: 12px;
    }

    svg {
      width: 16px;
      height: 16px;
    }
  }
}
</style>
